export const inspectModule = ({ scope, specifier }: { scope: string; specifier: string }) => {
  return `Module{scope=${scope},specifier=${specifier}}`;
};
